import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
const API = window.location.origin + '/api';
const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const handleReset = async () => {
    if (password !== confirm) return setError('Passwords do not match');
    setLoading(true); setError('');
    try { await axios.post(`${API}/reset/reset`, { token, password }); navigate('/login'); }
    catch (err: any) { setError(err.response?.data?.error || 'Failed'); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-black text-2xl" style={{ backgroundColor: '#B8860B' }}>X</div>
          <p className="font-bold text-gray-900 text-lg">BULLIONX</p>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-6">Set new password</h2>
        {error && <p className="text-red-500 text-xs mb-4">{error}</p>}
        <input type="password" placeholder="New password" value={password} onChange={e => setPassword(e.target.value)} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none mb-4" />
        <input type="password" placeholder="Confirm password" value={confirm} onChange={e => setConfirm(e.target.value)} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none mb-6" />
        <button onClick={handleReset} disabled={loading || !password || !confirm} className="w-full py-3 rounded-lg text-white text-sm font-semibold disabled:opacity-50" style={{ backgroundColor: '#1a1a2e' }}>{loading ? 'Resetting...' : 'Reset password'}</button>
      </div>
    </div>
  );
};
export default ResetPassword;
